var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('component-banner-service',{attrs:{"title":"Conheça o serviço","bold-title":"Web Hosting","description":"Crie, hospede o website da sua empresa sem complicações. O nosso serviço de web e-mail serve para todas as empresas.","my-style":_vm.dt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }